import { render, staticRenderFns } from "./EaNotActiveGiveaway.vue?vue&type=template&id=1ef1f7bf&lang=pug&"
import script from "./EaNotActiveGiveaway.vue?vue&type=script&lang=js&"
export * from "./EaNotActiveGiveaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports